import type { ProjectStatus } from '../types';

const LABELS: Record<ProjectStatus, string> = {
  Live: 'Live',
  InProduction: 'In production',
  InDevelopment: 'In development',
};

const TONES: Record<ProjectStatus, string> = {
  Live: 'text-live',
  InProduction: 'text-prod',
  InDevelopment: 'text-dev',
};

/**
 * The wire value is the enum name; the display text lives here.
 *
 * Colour is never the sole carrier of meaning — the badge always shows the label as
 * well as the dot.
 */
export function StatusBadge({ status }: { readonly status: ProjectStatus }) {
  return (
    <span
      className={`ml-2 inline-flex items-center gap-1.5 align-middle text-[10px] font-semibold uppercase tracking-label whitespace-nowrap ${TONES[status]}`}
    >
      <span aria-hidden="true" className="relative size-[5px] rounded-full bg-current" />
      {LABELS[status]}
    </span>
  );
}
